import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import {
    Border,
    Spacing,
} from '@uipath/apollo-core';
import { ApSkeleton } from '@uipath/portal-shell-react';
import React from 'react';

import { consumableCardFrame } from './cardStyles';

const useStyles = makeStyles(theme =>
    createStyles({
        card: {
            ...consumableCardFrame(theme),
            gap: Spacing.SpacingS,
        },
        title: {
            width: '45%',
            height: '20px',
            borderRadius: Border.BorderRadiusM,
        },
        subtitle: {
            width: '55%',
            height: '14px',
            borderRadius: Border.BorderRadiusM,
        },
        bigNumber: {
            width: '35%',
            height: '26px',
            borderRadius: Border.BorderRadiusM,
        },
        progressRow: {
            display: 'flex',
            alignItems: 'center',
            gap: Spacing.SpacingS,
        },
        progressBar: {
            flex: 1,
            height: '8px',
            borderRadius: Border.BorderRadiusNone,
        },
        progressPercent: {
            flex: 'none',
            width: '32px',
            height: '14px',
            borderRadius: Border.BorderRadiusM,
        },
        footer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: 'auto',
            paddingTop: Spacing.SpacingXs,
            borderTop: `1px solid ${theme.palette.semantic.colorBorderDeEmp}`,
            gap: Spacing.SpacingBase,
        },
        footerLeft: {
            width: '30%',
            height: '14px',
            borderRadius: Border.BorderRadiusM,
        },
        footerRight: {
            width: '25%',
            height: '14px',
            borderRadius: Border.BorderRadiusM,
        },
    }),
);

export const UiConsumableCardSkeletonV2: React.FC = () => {
    const classes = useStyles();

    return (
        <div
            className={classes.card}
            data-cy="consumables-v2-card-skeleton">
            <ApSkeleton
                variant="rectangle"
                className={classes.title} />
            <ApSkeleton
                variant="rectangle"
                className={classes.subtitle} />
            <ApSkeleton
                variant="rectangle"
                className={classes.bigNumber} />
            <div className={classes.progressRow}>
                <ApSkeleton
                    variant="rectangle"
                    className={classes.progressBar} />
                <ApSkeleton
                    variant="rectangle"
                    className={classes.progressPercent} />
            </div>
            <div className={classes.footer}>
                <ApSkeleton
                    variant="rectangle"
                    className={classes.footerLeft} />
                <ApSkeleton
                    variant="rectangle"
                    className={classes.footerRight} />
            </div>
        </div>
    );
};
